import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { startCase } from 'lodash/string';
import Form from '../../../../../components/Form';
import Input from '../../../../../components/Input';
import InputRestictMarkup from '../../../../../components/InputRestictMarkup';
import WYSIWYG from '../../../../../components/WYSIWYG';
import messages from '../messages';
import elementIds from '../elementIds';
import FieldError from '../FieldError';
import '../styles.css';

const ProfileStudentForm = ({ personsName, hometown, major, quote, body, favActivities, favHangout,
  bestPlaceToEat, favEvent, favTradition, travel, errors, onChange, formatMessage, type }) => (
    <React.Fragment>
      <Form.Field required error={errors.personsName} styleName="form-field name-field">
        <label className="form-label" htmlFor={elementIds.personsName}>
          <FormattedMessage {...messages.persons_name} />
        </label>
        <Input
          styleName="form-input"
          type="text"
          id={elementIds.personsName}
          aria-invalid={errors.personsName}
          aria-required="true"
          name="personsName"
          value={personsName}
          onChange={onChange}
          fluid
        />
        {errors.personsName && <FieldError message={messages.invalid_persons_name} />}
      </Form.Field>
      <Form.Field required error={errors.hometown} styleName="form-field">
        <label className="form-label" htmlFor={elementIds.hometown}>
          <FormattedMessage {...messages.hometown} />
        </label>
        <Input
          styleName="form-input"
          type="text"
          id={elementIds.hometown}
          aria-invalid={errors.hometown}
          aria-required="true"
          name="hometown"
          value={hometown}
          placeholder={formatMessage(messages.hometown_placeholder)}
          onChange={onChange}
          fluid
        />
        {errors.hometown && <FieldError message={messages.invalid_hometown} />}
      </Form.Field>
      <Form.Field required error={errors.major} styleName="form-field">
        <label className="form-label" htmlFor={elementIds.major}>
          <FormattedMessage {...messages.major} />
        </label>
        <Input
          styleName="form-input"
          type="text"
          id={elementIds.major}
          aria-invalid={errors.major}
          aria-required="true"
          name="major"
          value={major}
          placeholder={formatMessage(messages.major_placeholder)}
          onChange={onChange}
          fluid
        />
        {errors.major && <FieldError message={messages.invalid_major} />}
      </Form.Field>
      <Form.Field required error={errors.quote} styleName="form-field">
        <label className="form-label" htmlFor={elementIds.quote}>
          <FormattedMessage {...messages.quote} />
        </label>
        <InputRestictMarkup
          styleName="form-input"
          type="text"
          id={elementIds.quote}
          aria-invalid={errors.quote}
          aria-required="true"
          name="quote"
          value={quote}
          placeholder={formatMessage(messages.quote_placeholder)}
          onChange={onChange}
          fluid
        />
        {errors.quote && <FieldError message={messages.invalid_quote} />}
      </Form.Field>
      <Form.Field required error={errors.body} styleName="form-field body">
        <label className="form-label" htmlFor={elementIds.body}>
          <FormattedMessage values={{ type: startCase(type) }} {...messages.about} />
        </label>
        <WYSIWYG
          className="edit-modal-wysiwyg-container"
          styleName="form-wysiwyg"
          id={elementIds.body}
          aria-invalid={errors.body}
          aria-required="true"
          name="body"
          type="textarea"
          limit={0}
          mode="extended"
          value={body}
          onChange={onChange}
          placeholder=""
          fluid
        />
        {errors.body && <FieldError message={messages.invalid_about} />}
      </Form.Field>
      <Form.Field error={errors.favActivities} styleName="form-field">
        <label className="form-label" htmlFor={elementIds.favActivities}>
          <FormattedMessage {...messages.fav_activities} />
        </label>
        <Input
          styleName="form-input"
          type="text"
          id={elementIds.favActivities}
          name="favActivities"
          value={favActivities}
          onChange={onChange}
          fluid
        />
      </Form.Field>
      <Form.Field error={errors.favHangout} styleName="form-field">
        <label className="form-label" htmlFor={elementIds.favHangout}>
          <FormattedMessage {...messages.fav_hangout} />
        </label>
        <Input
          styleName="form-input"
          type="text"
          id={elementIds.favHangout}
          name="favHangout"
          value={favHangout}
          onChange={onChange}
          fluid
        />
      </Form.Field>
      <Form.Field error={errors.bestPlaceToEat} styleName="form-field">
        <label className="form-label" htmlFor={elementIds.bestPlaceToEat}>
          <FormattedMessage {...messages.best_place_to_eat} />
        </label>
        <Input
          styleName="form-input"
          type="text"
          id={elementIds.bestPlaceToEat}
          name="bestPlaceToEat"
          value={bestPlaceToEat}
          onChange={onChange}
          fluid
        />
      </Form.Field>
      <Form.Field error={errors.favEvent} styleName="form-field">
        <label className="form-label" htmlFor={elementIds.favEvent}>
          <FormattedMessage {...messages.fav_event} />
        </label>
        <Input
          styleName="form-input"
          type="text"
          id={elementIds.favEvent}
          name="favEvent"
          value={favEvent}
          onChange={onChange}
          fluid
        />
      </Form.Field>
      <Form.Field error={errors.favTradition} styleName="form-field">
        <label className="form-label" htmlFor={elementIds.favTradition}>
          <FormattedMessage {...messages.fav_tradition} />
        </label>
        <Input
          styleName="form-input"
          type="text"
          id={elementIds.favTradition}
          name="favTradition"
          value={favTradition}
          onChange={onChange}
          fluid
        />
      </Form.Field>
      <Form.Field error={errors.travel} styleName="form-field">
        <label className="form-label" htmlFor={elementIds.travel}>
          <FormattedMessage {...messages.travel} />
        </label>
        <Input
          styleName="form-input"
          type="text"
          id={elementIds.travel}
          name="travel"
          value={travel}
          onChange={onChange}
          fluid
        />
      </Form.Field>
    </React.Fragment>
);

ProfileStudentForm.propTypes = {
  personsName: PropTypes.string.isRequired,
  hometown: PropTypes.string.isRequired,
  major: PropTypes.string.isRequired,
  quote: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  favActivities: PropTypes.string.isRequired,
  favHangout: PropTypes.string.isRequired,
  bestPlaceToEat: PropTypes.string.isRequired,
  favEvent: PropTypes.string.isRequired,
  favTradition: PropTypes.string.isRequired,
  travel: PropTypes.string.isRequired,
  errors: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  formatMessage: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
};

export default ProfileStudentForm;
